import { c as _c } from "react/compiler-runtime";
import type { VaultProxyLogRevealResponse } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import LogContentField from './components/log-content-field';
import LogField from './components/log-field';
type LogItemDetailsProps = {
  data: VaultProxyLogRevealResponse;
};
const LogItemDetails = t0 => {
  const $ = _c(58);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "details.logs.detailsDialog"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("vault-proxy", t1);
  const {
    method,
    url,
    sentAt,
    requestDataB64,
    statusCode,
    receivedAt,
    responseDataB64
  } = data;
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <h3 className="py-3 px-4 text-label-2 text-primary border-b border-solid border-tertiary">{t2}</h3>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp2);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== method || $[8] !== t4) {
    t5 = <LogField label={t4} value={method} />;
    $[7] = method;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t(_temp3);
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6 || $[13] !== url) {
    t7 = <LogField label={t6} value={url} />;
    $[12] = t6;
    $[13] = url;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t(_temp4);
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== sentAt || $[18] !== t8) {
    t9 = <LogField label={t8} value={sentAt} />;
    $[17] = sentAt;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== requestDataB64) {
    t10 = <LogContentField base64Value={requestDataB64} />;
    $[20] = requestDataB64;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t5 || $[24] !== t7 || $[25] !== t9) {
    t11 = <div className="flex flex-col gap-2 py-3 px-4 border-b border-solid border-tertiary">{t5}{t7}{t9}{t10}</div>;
    $[22] = t10;
    $[23] = t5;
    $[24] = t7;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t3) {
    t12 = <div className="flex flex-col">{t3}{t11}</div>;
    $[27] = t11;
    $[28] = t3;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t) {
    t13 = t(_temp5);
    $[30] = t;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t13) {
    t14 = <h3 className="py-3 px-4 text-label-2 text-primary border-b border-solid border-tertiary">{t13}</h3>;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t) {
    t15 = t(_temp6);
    $[34] = t;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== statusCode) {
    t16 = statusCode?.toString();
    $[36] = statusCode;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== t15 || $[39] !== t16) {
    t17 = <LogField label={t15} value={t16} />;
    $[38] = t15;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t) {
    t18 = t(_temp7);
    $[41] = t;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== receivedAt || $[44] !== t18) {
    t19 = <LogField label={t18} value={receivedAt} />;
    $[43] = receivedAt;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== responseDataB64) {
    t20 = <LogContentField base64Value={responseDataB64} />;
    $[46] = responseDataB64;
    $[47] = t20;
  } else {
    t20 = $[47];
  }
  let t21;
  if ($[48] !== t17 || $[49] !== t19 || $[50] !== t20) {
    t21 = <div className="flex flex-col gap-2 py-3 px-4">{t17}{t19}{t20}</div>;
    $[48] = t17;
    $[49] = t19;
    $[50] = t20;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== t14 || $[53] !== t21) {
    t22 = <div className="flex flex-col">{t14}{t21}</div>;
    $[52] = t14;
    $[53] = t21;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== t12 || $[56] !== t22) {
    t23 = <div className="ml-6 mt-2 flex flex-col bg-secondary rounded-md">{t12}{t22}</div>;
    $[55] = t12;
    $[56] = t22;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  return t23;
};
export default LogItemDetails;
function _temp($) {
  return $.request;
}
function _temp2($_0) {
  return $_0.method;
}
function _temp3($_1) {
  return $_1.url;
}
function _temp4($_2) {
  return $_2.timestamp;
}
function _temp5($_3) {
  return $_3.response;
}
function _temp6($_4) {
  return $_4.status;
}
function _temp7($_5) {
  return $_5.timestamp;
}